<template lang="pug">
.doSINGLECHOICE
  .cont  {{cont.stem}}
  .hint {{cont.hint}}
  CheckboxGroup(v-model="item.option")
      Checkbox(v-for='(v,index) in JSON.parse(cont.metas)',
        ,:disabled='cont.isShow||Completed'
        :key='index'
        :label='index',style='display: block;')  {{optionList[index]}}、{{v}}
</template>

<script>
export default {
  props: ["cont", "HistoryData"],
  data() {
    return {
      optionList: ["A", "B", "C", "D", "E", "F", "G", "I", "H"],
      Completed: sessionStorage.getItem("Completed") === "true",
      item: {
        option: []
      },
      id: false
    };
  },
  created() {
    if (this.cont.isShow) {
      this.item.option = JSON.parse(this.cont.answer);
    }
    if (this.HistoryData) {
      this.item.option = JSON.parse(this.HistoryData.questionAnswer);
      this.id = this.HistoryData.id;
    }
  }
};
</script>

<style lang="stylus" scoped>
.doSINGLECHOICE
  width 100%
  .cont
    margin-bottom 10px
    font-size 16px
    font-family MicrosoftYaHeiUI
    color rgba(42, 46, 54, 0.75)
    line-height 20px
  .hint
    margin-bottom 8px
    color #7b7272
</style>
